export enum DateTrustCode {
  invalid = 'invalid',
  day = 'day',
  month = 'month',
  dayMonth = 'day + month',
  year = 'year',
  yearDay = 'year + day',
  yearMonth = 'year + month',
  yearDayMonth = 'year + day + month',
  null = '',
}

export type EntityId = number

export type Entity = {
  id: EntityId
  updatedAt?: string
  createdAt?: string
}
